// extracted by mini-css-extract-plugin
export default {"customTag":"team-custom-tag_customTag__bct3e"};